import { useEffect } from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import { useHistory, useLocation } from 'react-router-dom';

import { useHasAccessToOnboardingV3 } from '../components/OnboardingV3/hooks/useHasAccessToOnboardingV3';

export const RedirectClientToOnboardingV3 = () => {
  const history = useHistory();
  const location = useLocation();
  const currentApp = useAppSelector((state) => state.currentApp);
  // can't access params here because it's not available in the router yet
  const appId = location.pathname.split('/')[1];

  const { onboardingStatus, isFlipdishStaff, permissionsLoaded } = useHasAccessToOnboardingV3();

  useEffect(() => {
    const shouldRedirect =
      permissionsLoaded &&
      onboardingStatus === 'in_progress' &&
      !isFlipdishStaff &&
      !location.pathname.includes('/setup') &&
      !location.pathname.includes('/profile') &&
      //edge case when changing appId/no currentApp (loading)
      appId &&
      appId === currentApp?.AppId;

    if (shouldRedirect) {
      history.replace(`/${appId}/setup`);
    }
  }, [
    permissionsLoaded,
    onboardingStatus,
    isFlipdishStaff,
    location.pathname,
    appId,
    history,
    currentApp?.AppId,
  ]);

  return null;
};

export default RedirectClientToOnboardingV3;
